import { cn } from '@/utils'
import { useEffect } from 'react'

import { Button } from '@/components/ui/button'
import { useDocumentPageQuery } from '@/pages/DocumentPage/queries'

export const PDFDownloadButton = ({
  onDownload,
}: {
  onDownload: () => void
}) => {
  const { isLoading, data } = useDocumentPageQuery()
  const documentVersionId = data?.documentVersion?.id
  const pdfURL = data?.documentVersion?.pdf_url
  const isEnabled = !isLoading && !!pdfURL && !!documentVersionId

  useEffect(() => {
    if (window.Cypress && documentVersionId) {
      // @ts-expect-error - extending window for Cypress testing
      window.$$documentVersionId = documentVersionId
    }
  }, [documentVersionId])

  return (
    <Button
      variant="ghost"
      data-testid="download-pdf-button"
      disabled={!isEnabled}
      className={cn('flex items space-x-2', {
        'text-gray-400 cursor-not-allowed': !isEnabled,
      })}
      onClick={() => {
        window.open(pdfURL)
        onDownload()
      }}
    >
      <span>Download Document (.pdf)</span>
    </Button>
  )
}
